module.exports = __webpack_public_path__ + "assets/tag.fe73d287.svg";